import {
    type FC
} from "react";
import type ILoadingProps from "./type";
import stylesheet from "./stylesheet";
import LoadingIcon from "../../assets/svg/loadingIcon";

const Loading: FC<ILoadingProps> = ({
    color = "emphasized" as keyof NCoreUIKit.IconContentColors,
    customColor,
    size = 22,
    style,
    ...props
}) => {
    return <LoadingIcon
        {...props}
        style={{
            ...stylesheet.container,
            ...style
        }}
        customColor={customColor}
        color={color}
        size={size}
    />;
};
export default Loading;
